import { RevenueCatWebhookBody } from '@inkitt/contracts-common';
import { z } from 'zod';
import { c } from '../../../contract';

export const revenueCatRouter = c.router(
  {
    event: {
      path: '/event',
      method: 'POST',
      body: RevenueCatWebhookBody,
      responses: {
        200: z.object({
          result: z.literal('OK'),
          message: z.string().optional(),
        }),
      },
    },
    test: {
      path: '/test',
      method: 'POST',
      body: RevenueCatWebhookBody,
      responses: {
        200: z.object({
          result: z.literal('OK'),
          message: z.string().optional(),
        }),
      },
    },
    // Dedicated endpoint for the Audiobooks Plus (Litly) RevenueCat project. It processes ONLY
    // one-time coin purchases (NON_RENEWING_PURCHASE) and attributes Adjust events to the audiobooks
    // app; every subscription event type is ignored (Litly is coins-only).
    audiobooks: c.router(
      {
        event: {
          path: '/event',
          method: 'POST',
          body: RevenueCatWebhookBody,
          responses: {
            200: z.object({
              result: z.literal('OK'),
              message: z.string().optional(),
            }),
          },
        },
      },
      { pathPrefix: '/audiobooks' },
    ),
  },
  { pathPrefix: '/revenue-cat' },
);
